var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink02 = function SvgLink02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000713",
    fillRule: "evenodd",
    d: "M5.067 5.333a2.667 2.667 0 0 0 0 5.334H6.4A.667.667 0 1 1 6.4 12H5.067a4 4 0 0 1 0-8H6.4a.667.667 0 0 1 0 1.333zm4.666-.666c0-.369.299-.667.667-.667h1.333a4 4 0 1 1 0 8H10.4a.667.667 0 0 1 0-1.333h1.333a2.667 2.667 0 1 0 0-5.334H10.4a.667.667 0 0 1-.667-.666M4.4 8c0-.368.298-.667.667-.667h6.666a.667.667 0 1 1 0 1.334H5.067A.667.667 0 0 1 4.4 8",
    clipRule: "evenodd"
  })));
};
export default SvgLink02;